// recipients-view.store.ts
// What is shown in the list of the recipients of a project : the filter on the files to correct and the number of files of each filter.
// View state only (the users themselves stay in the user store) : it is not persisted.
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

//Filters of the list, in the order they are offered ("" = all the recipients)
export const RECIPIENTS_FILTERS = ["toFix", "unreachable", "noEmail", "noAddress", "language", "empty"] as const
export type RecipientsFilter = "" | (typeof RECIPIENTS_FILTERS)[number]

export interface RecipientsViewState {
  filter: RecipientsFilter
  counts: { [filter: string]: number }
}

const initialState: RecipientsViewState = { filter: "", counts: {} }

const recipientsViewSlice = createSlice({
  name: "recipientsView",
  initialState,
  reducers: {
    setFilter(state, action: PayloadAction<RecipientsFilter>) {
      state.filter = action.payload
    },
    setCounts(state, action: PayloadAction<{ [filter: string]: number }>) {
      state.counts = action.payload
    },
    reset() {
      return initialState
    }
  }
})

//Number of files of each filter, from the answer of the server (the same everywhere the list is loaded)
export function toRecipientsCounts(recipients: any): { [filter: string]: number } {
  return {
    toFix: recipients.countToFix || 0,
    unreachable: recipients.countUnreachable || 0,
    noEmail: recipients.countWithoutEmail || 0,
    noAddress: recipients.countWithoutAddress || 0,
    language: recipients.countLanguageAbsent || 0,
    empty: recipients.countEmpty || 0
  }
}

//The active filter has no file left (the last one was corrected) : the list goes back to all the recipients.
//Not during a search, the numbers are then those of the search
export function isActiveFilterEmpty(filter: RecipientsFilter, counts: { [filter: string]: number }, search: string): boolean {
  return filter !== "" && !search && !counts[filter]
}

export const recipientsViewActions = recipientsViewSlice.actions
export const selectRecipientsFilter = (state: any): RecipientsFilter => state.recipientsView.filter
export const selectRecipientsCounts = (state: any): { [filter: string]: number } => state.recipientsView.counts
export default recipientsViewSlice.reducer
